import styled from "@emotion/styled";
import { Box, Paper, Typography } from "@mui/material";
import CheckCircle from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

export const SnackbarContainer = styled(Paper)(({ theme }) => ({
	padding: "6px 16px",
	backgroundColor: theme.project.colors.allColors.hex.grayscale.gray900,
	color: theme.project.colors.fontColors.contrast,
	display: "flex",
	alignItems: "center",
	elevation: 6,
	height: "38px",
	width: "auto"
}));

export const SnackbarContent = styled(Box)({
	display: "flex",
	alignItems: "center",
	gap: "8px"
});

export const SnackbarText = styled(Typography)(({ theme }) => ({
	...theme.project.typography.body.body2
}));

export const StyledCheckCircle = styled(CheckCircle)(({ theme }) => ({
	width: "16px",
	height: "16px",
	color: theme.project.colors.allColors.hex.green.green500
}));

export const StyledCancelIcon = styled(CancelIcon)(({ theme }) => ({
	width: "16px",
	height: "16px",
	color: theme.palette.error.light
}));
